// APP CONFIG
export const $themeConfig = {
    locale: 'en',
    theme: 'light',
    menu: 'horizontal',
    layout: 'full',
    rtlClass: 'ltr',
    animation: '',
    navbar: 'navbar-sticky',
    semidark: false,
};

